import { render } from "./project-app.html?vue&type=template&id=1736b25a&scoped=true&ts=true"
import script from "./project-app.ts?vue&type=script&lang=ts"
export * from "./project-app.ts?vue&type=script&lang=ts"

import "./project-app.scss?vue&type=style&index=0&id=1736b25a&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1736b25a"]])

export default __exports__